/**
 * Created by Ning Jiang on 6/29/2017.
 */

import {WixxReelController} from "./WixxReelController";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStopSpinData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";

export class WixxFirstNearWinReelController extends WixxReelController {

    private _spinStartedTime:number;

    constructor(reelId:number) {
        super(reelId);
    }

    protected onSpinStartedCompleted():void {
        super.onSpinStartedCompleted();

        if(this._gameMode === GameMode.RESPIN) {
            this.tryPlayNearWin(0);
            this._spinStartedTime = Date.now();
        }
    }

    public hasNearWin():boolean {
        return this._gameMode === GameMode.RESPIN ? true : super.hasNearWin();
    }

    public stopSpin(data:IReelStopSpinData, delay:number):number {
        // quick stop doesn't go here.
        if(this._gameMode === GameMode.RESPIN) {
            const timePassed:number = (Date.now() - this._spinStartedTime) / 1000;
            delay = Math.max(0, delay - timePassed);
        }

        return super.stopSpin(data, delay);
    }
}